const lazyLoad = () => {
    const images = document.querySelectorAll('.lazy')

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, obs) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const image = entry.target

                    const img = image.querySelector('img')
                    if (img && img.hasAttribute('data-src')) {
                        img.setAttribute('src', img.getAttribute('data-src'))
                        img.removeAttribute('data-src')
                    }

                    const sources = image.querySelectorAll('source')
                    sources.forEach(source => {
                        if (source.hasAttribute('data-srcset')) {
                            source.setAttribute('srcset', source.getAttribute('data-srcset'))
                            source.removeAttribute('data-srcset')
                        }
                    })
                    obs.unobserve(image)
                }
            })
        }, {
            rootMargin: '0px 0px 200px 0px',
            threshold: 0.01
        })

        images.forEach(image => {
            observer.observe(image)
        })
    } else {
        // if intersection observer is not supported, load all images immediately
        images.forEach(image => {
            const img = image.querySelector('img')
            if (img && img.hasAttribute('data-src')) {
                img.setAttribute('src', img.getAttribute('data-src'))
                img.removeAttribute('data-src')
            }
            const sources = image.querySelectorAll('source')
            sources.forEach(source => {
                if (source.hasAttribute('data-srcset')) {
                    source.setAttribute('srcset', source.getAttribute('data-srcset'))
                    source.removeAttribute('data-srcset')
                }
            })
        })
    }
}

export default lazyLoad
